(function () {
  function animateCounter(el, target) {
    var duration = 1500;
    var start = performance.now();
    var from = 0;

    function step(timestamp) {
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.floor(from + (target - from) * eased);
      el.textContent = value.toString();

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toString();
      }
    }

    requestAnimationFrame(step);
  }

  function initProvenResults(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-proven-results-section]');

    sections.forEach(function (section) {
      if (section.dataset.countersInitialized === 'true') return;
      section.dataset.countersInitialized = 'true';

      var counterGroup = section.querySelector('[data-counter-group]');
      if (!counterGroup) return;

      var counters = counterGroup.querySelectorAll('[data-counter-value]');
      if (!counters.length) return;

      var started = false;

      function runCounters() {
        if (started) return;
        started = true;

        counters.forEach(function (counter) {
          var end = parseInt(counter.getAttribute('data-counter-end'), 10);
          if (isNaN(end)) return;
          animateCounter(counter, end);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                runCounters();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );

        observer.observe(counterGroup);
      } else {
        runCounters();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProvenResults(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProvenResults(event.target);
  });
})();
